import { Link } from 'react-router-dom';

// Extracted from HomePage.jsx (2026-07-10) into a shared component so every
// public page gets the same footer instead of each one copy-pasting its own
// — previously only 4 of ~20 public pages had a footer at all, each with
// independently duplicated markup.
//
// The three text colors below were bumped from their original opacities
// (0.20, 0.25, 0.30) to 0.55 — computed against the real WCAG contrast
// formula (not eyeballed): white text at those original opacities on this
// background (#080f1a) measured 1.81:1, 2.19:1, and 2.64:1, all failing the
// 4.5:1 AA minimum for normal text. 0.55 measures 6.23:1, a real, comfortable
// pass rather than sitting right at the 4.5 threshold. The existing 0.45/0.70
// link colors were already passing (4.51:1) and are unchanged.
export default function Footer() {
  return (
    <footer style={{ background: '#080f1a' }} className="px-6 lg:px-10 pt-14 pb-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start gap-10 mb-10">
          <div>
            <p className="font-extrabold text-white mb-2 tracking-tight" style={{ fontSize: 20 }}>
              Centric<span style={{ color: '#C1272D' }}>Q</span>
            </p>
            <p className="max-w-[220px] leading-[1.65]" style={{ fontSize: 14, color: 'rgba(255,255,255,0.55)' }}>
              The complete AI-powered interview preparation platform.
            </p>
          </div>
          <div className="flex gap-12 flex-wrap">
            {[
              { heading: 'Product', links: [['Browse roles', '/roles'], ['Study Guides', '/courses'], ['JD Prep', '/jd-prep'], ['Pricing', '/pricing']] },
              { heading: 'Account', links: [['Sign in', '/login'], ['Create account', '/register'], ['Dashboard', '/dashboard']] },
              { heading: 'Company', links: [['About', '/about'], ['Contact', '/contact'], ['For Companies', '/company/login']] },
              { heading: 'Legal', links: [['Privacy policy', '/privacy'], ['Terms of service', '/terms']] },
            ].map(({ heading, links }) => (
              <div key={heading}>
                <p className="font-bold uppercase tracking-[0.1em] mb-4" style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)' }}>{heading}</p>
                {links.map(([label, to]) => (
                  <Link key={label} to={to} className="block no-underline mb-2.5 transition-colors duration-200"
                    style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)' }}
                    onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.70)'}
                    onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.45)'}>
                    {label}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className="border-t pt-6 flex flex-col sm:flex-row justify-between gap-3" style={{ borderColor: 'rgba(255,255,255,0.07)' }}>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)' }}>© {new Date().getFullYear()} CentricQ. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="no-underline transition-colors" style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)' }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.80)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'}>Privacy</Link>
            <Link to="/terms"   className="no-underline transition-colors" style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)' }} onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.80)'} onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'}>Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
